// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


// This file can be replaced during build by using the `fileReplacements` ang sevrrray.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
    production: false,
     
     apiUrl: 'http://localhost:4000',
     //Base_url : 'https://isgmv.co.in:9030/cessmodule/v1/api/',
     //isgPayUrl: 'https://sandbox.isgpay.com/payments-idbi/request.action',
     Base_url : 'https://idbi.isgpay.com/cessmodule/v1/api/',
     isgPayUrl: 'https://isgpay.com/ISGPay-Genius/request.action' 

};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
